import { IDB_activityOverwritesDelete, IDB_activityOverwritesReadAll } from '../IDB/IDB.table.activityOverwrite'
import { Logg_event } from '../Logg/Logg.event'
import type { Type_IActivityOverwrite } from '../Type/Type.hive'

export async function Acti_deleteActivitiesOverwrite() {
    Logg_event('Start', { label: 'activity.deleteActivitiesOverwrite' })

    const entries = await IDB_activityOverwritesReadAll().catch<Type_IActivityOverwrite[]>(() => [])
    entries.forEach(async (activity) => {
        await IDB_activityOverwritesDelete([activity.id]).catch<Type_IActivityOverwrite>(() => null)
    })
}
